import { SessionStatus } from "@/store/sessions/types";
import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds";

interface SessionStatusIconProps {
  status: SessionStatus;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const SessionStatusIcon: React.FC<SessionStatusIconProps> = ({ status }) => {
  switch (status) {
    case "PROCESSING":
      return <MDSIcon kind={MDSIconKind.Spinner} size={16} boxSize={32} />;
    case "FINISHED":
      return (
        <MDSIcon
          kind={MDSIconKind.CheckCircleSolid}
          size={16}
          boxSize={32}
          color={MDSIconColor.Positive}
        />
      );
    case "ERROR":
      return (
        <MDSIcon
          kind={MDSIconKind.ExclamationSolid}
          size={16}
          boxSize={32}
          color={MDSIconColor.Danger}
        />
      );
  }
};
